import React from "react";
import Scene from "./Scene";
import './styles.css'
function App() {
  return (
    <div style={{ 
      width: "100vw", 
      height: "100vh",
      backgroundColor: "#ecefde", // Match Canvas background color
      margin: 0,
      padding: 0,
      overflow: "hidden"
    }}>
      <Scene />
    </div>
  );
}

export default App;
